// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Pure functions for grouping documents by group ID.
 */

import type { DocumentListItem } from '@/subsystems/documents'

/**
 * Group documents by groupId into a Map.
 * Documents without groupId are excluded.
 */
export function groupDocumentsByGroupId(documents: DocumentListItem[]): Map<string, DocumentListItem[]> {
  const grouped = new Map<string, DocumentListItem[]>()

  for (const doc of documents) {
    if (!doc.groupId) continue
    const existing = grouped.get(doc.groupId) ?? []
    existing.push(doc)
    grouped.set(doc.groupId, existing)
  }

  return grouped
}
